import { render, staticRenderFns } from "./CustomizeMetalF.vue?vue&type=template&id=874ad7ac&scoped=true"
import script from "./CustomizeMetalF.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalF.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalF.vue?vue&type=style&index=0&id=874ad7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874ad7ac",
  null
  
)

export default component.exports